export default __webpack_public_path__ + "static/media/Management-documentation.9b188d78.md";